// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__uQKEa","name":"ConsentHeader_name__1_oOn","birthday":"ConsentHeader_birthday__jgDkS","skeleton":"ConsentHeader_skeleton__2xOW5"};